import * as React from "react";
import type { RouteComponentProps } from "react-router";
import { withRouter } from "react-router";
import ExternalLink from "../Navigation/ExternalLink/ExternalLink";
import InternalLink from "../Navigation/InternalLink/InternalLink";
import { isInternalLinkPart, isTextPart, parseMarkdownLinks } from "./parseLinks";
interface InternalTextWithLinksProps {
    message: string;
    allowHtml: boolean;
}
type InternalLinkProps = InternalTextWithLinksProps & RouteComponentProps<{
    spaceId: string;
}>;
class TextWithLinks extends React.Component<InternalLinkProps> {
    render() {
        const parsed = parseMarkdownLinks(this.props.message);
        // Faster rendering if there are no links
        if (!this.props.allowHtml && parsed.length == 1 && isTextPart(parsed[0])) {
            return <>{this.props.message}</>;
        }
        return parsed.map((part, index) => {
            if (isTextPart(part)) {
                return this.props.allowHtml ? <span key={index} dangerouslySetInnerHTML={{ __html: part.content }}/> : <span key={index}>{part.content}</span>;
            }
            if (isInternalLinkPart(part)) {
                return (<InternalLink key={index} to={part.internalUrl}>
                        {part.text}
                    </InternalLink>);
            }
            return (<ExternalLink key={index} href={part.externalUrl}>
                    {part.text}
                </ExternalLink>);
        });
    }
    static displayName = "TextWithLinks";
}
export default withRouter(TextWithLinks);
